import type {Me} from "@/src/modules/core/types";

/** GlitchTip tag only — never send the full Role object (permissions leak). */
export function getUserRoleSlug(role: Me["role"]): string {
  if (typeof role === "string") return role;
  if (!role || typeof role !== "object") return "unknown";

  const slug = "slug" in role && typeof role.slug === "string" ? role.slug : undefined;
  if (slug) return slug;

  if (typeof role.name === "string" && role.name.length > 0) {
    return role.name.trim().replace(/\s+/g, "_").toLowerCase();
  }

  return "unknown";
}
